<template lang="pug">
  div
    Header
    v-content
      v-container(fluid class="px-0")
        MainBlock
        v-row(no-gutters)
          v-flex(xs9 class="pr-7")
            CategoryAdvertsCount
          v-flex(xs3)
            v-img(
              :src="require('@/assets/banners/main_page_banner_right.png')",
              style="border-radius: 6px;")
</template>

<script>
export default {
  name: 'home',
  components: {
    Header: () => import('@/components/Header'),
    MainBlock: () => import('@/components/blocks/MainBlock'),
    CategoryAdvertsCount: () =>
      import('@/components/blocks/CategoryAdvertsCount')
  }
}
</script>
